export enum PaymentStatusEnum {
  PAID = "PAYMENT_STATUS_ENUM_PAID",
  PROCESSING = "PAYMENT_STATUS_ENUM_PROCESSING",
}
